import React, { useEffect } from 'react';
import { FiShield, FiLock, FiEye, FiServer, FiMail } from 'react-icons/fi';
import Navbar from '../components/home/Navbar';
import Footer from '../components/home/Footer';

export default function Privacy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar />

            <main className="flex-grow pt-32 pb-20 px-4">
                <div className="max-w-4xl mx-auto">
                    {/* Header */}
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center justify-center p-3 bg-blue-100 text-blue-600 rounded-2xl mb-4">
                            <FiShield size={32} />
                        </div>
                        <h1 className="text-4xl font-bold text-gray-900 mb-4 poppins">Privacy Policy</h1>
                        <p className="text-gray-600 font-medium poppins">Last updated: January 1, 2026</p>
                    </div>

                    {/* Content */}
                    <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10 poppins">
                        <section>
                            <div className="flex items-center gap-3 mb-4 text-blue-600">
                                <FiEye size={20} />
                                <h2 className="text-xl font-bold">Information We Collect</h2>
                            </div>
                            <div className="text-gray-600 leading-relaxed space-y-4">
                                <p>
                                    At Sudesh Maths, we collect information to provide better services to all our students. The types of information we collect include:
                                </p>
                                <ul className="list-disc pl-6 space-y-2 font-medium">
                                    <li>Personal identification (Name, Email, Phone Number, Birthday)</li>
                                    <li>Educational details (Grade, Stream, School)</li>
                                    <li>Payment information (Bank slip images, transaction reference numbers)</li>
                                    <li>Profile information (Mailing address for delivery of materials)</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-center gap-3 mb-4 text-blue-600">
                                <FiLock size={20} />
                                <h2 className="text-xl font-bold">How We Use Your Information</h2>
                            </div>
                            <div className="text-gray-600 leading-relaxed space-y-4">
                                <p>
                                    We use the information we collect for various purposes, including:
                                </p>
                                <ul className="list-disc pl-6 space-y-2 font-medium">
                                    <li>To provide and maintain our educational services</li>
                                    <li>To process your payments and verify enrollment</li>
                                    <li>To deliver physical study materials to your provided address</li>
                                    <li>To communicate with you about classes, exams, and updates</li>
                                    <li>To improve our platform and user experience</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-center gap-3 mb-4 text-blue-600">
                                <FiServer size={20} />
                                <h2 className="text-xl font-bold">Data Security</h2>
                            </div>
                            <p className="text-gray-600 leading-relaxed font-regular">
                                We implement a variety of security measures to maintain the safety of your personal information. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential.
                            </p> section: {
                                // Important note about image data
                            }
                            <p className="text-gray-600 leading-relaxed mt-4">
                                <strong>Note regarding Payment Slips:</strong> Uploaded payment slips are used solely for verification purposes and are stored securely. Client-side compression is used to ensure efficient transmission while maintaining readability.
                            </p>
                        </section>

                        <section>
                            <div className="flex items-center gap-3 mb-4 text-blue-600">
                                <FiMail size={20} />
                                <h2 className="text-xl font-bold">Contact Us</h2>
                            </div>
                            <p className="text-gray-600 leading-relaxed font-regular mb-4">
                                If you have any questions regarding this privacy policy, you may contact us using the information below:
                            </p>
                            <div className="bg-blue-50 p-6 rounded-2xl">
                                <p className="font-bold text-gray-900">Sudesh Maths Portal</p>
                                <p className="text-gray-600">Email: support@sudeshmaths.com</p>
                                <p className="text-gray-600">Phone: 071 930 4566</p>
                            </div>
                        </section>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
